import React, { useRef } from "react";
import { GalleryElement } from "../../store/Gallery";
import { ImageLoader } from "../common/ImageLoader";

interface Props {
  element: GalleryElement;
  onNextClick: () => void;
  onPreviousClick: () => void;
}

const PopupGallerySlider = ({
  element,
  onNextClick,
  onPreviousClick,
}: Props) => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const adjustedImageUrl = element.imageUrl.replace(/^.*[\\/]/, "");

  return (
    <div className="wrapper" style={{ position: "relative" }} ref={divRef}>
      <div className="player-container">
        {element.link ? (
          <iframe
            title="video-player"
            src={element.link}
            id="youtube"
            className="img-player-el"
            scrolling="yes"
            allowFullScreen={true}
          ></iframe>
        ) : (
          <ImageLoader
            imageSrc={`./resources/images/gallery/${adjustedImageUrl}`}
            placholderImageSrc={`./resources/images/gallery/blur/${adjustedImageUrl}`}
          />
        )}
      </div>
      <div className="arrow arrow-left" onClick={onPreviousClick}>
        <span className="left"></span>
      </div>
      <div className="arrow arrow-right" onClick={onNextClick}>
        <span className="right"></span>
      </div>
    </div>
  );
};

export default PopupGallerySlider;
